import React, { useState } from "react";
import { TextField } from "@mui/material";
import { useCustomHook } from "../../../../GlobalFunctions/globalFunctions";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import { useEffect } from "react";
import { CONSULTATION_MODAL_ACTION_TYPE } from "../../../../../redux/actions-type";
import { useDispatch } from "react-redux";

const Status = ({ formik, modalData, updateModalState }) => {
  const { constStatusList: dataList } = useCustomHook();
  const currentStatusItem = dataList.find(
    (item) => item.key === modalData.status,
  );
  const dispatch = useDispatch();
  const [shrink, setShrink] = useState(false);
  const inputDate = modalData[currentStatusItem.dateField]
    ? moment(modalData[currentStatusItem.dateField])
        .locale("az")
        .format("DD MMMM YYYY")
    : "";
  const inputValue = currentStatusItem?.name
    ? `${currentStatusItem.name}     ${inputDate}`
    : "";
  const [openDropdown, setOpenDropdown] = useState(false);
  const addData = (item) => {
    updateModalState("status", item);
    setOpenDropdown(false);
  };

  return (
    <>
      <div className="class-input">
        <div className="dropdown-input">
          <div className="input-box">
            <TextField
              sx={{
                "& input": {
                  fontSize: "13px",
                  marginRight: "32px",
                },
                marginTop: "24px",
                // marginBottom: "24px",
              }}
              InputLabelProps={{
                style: { fontSize: "12px", color: "#3F3F3F" },
              }}
              fullWidth
              label="Status"
              autoComplete="off"
              disabled
              value={inputValue}
              onBlur={() => formik.setFieldTouched("status", true)}
            />
            <DropdownIcon
              setOpenDropdown={setOpenDropdown}
              openDropdown={openDropdown}
            />
          </div>

          <ul
            className={`dropdown-body where-coming ${
              openDropdown ? "active" : ""
            }`}
            style={{ height: "250px", maxHeight: "250px" }}
          >
            {dataList
              .filter((item) => item.isActive)
              .map((item) => (
                <li
                  key={item.key}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingRight: "10px",
                  }}
                >
                  <h4 onClick={() => addData(item.key)}>{item.name}</h4>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 1,
                    }}
                  >
                    <div className="status-date-input">
                      <DatePicker
                        selected={
                          modalData[item.dateField]
                            ? new Date(modalData[item.dateField])
                            : null
                        }
                        onChange={(date) => {
                          if (item.dateField === "contactDate") {
                            dispatch({
                              type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
                              payload: {
                                data: {
                                  ...modalData,
                                  contactDate: date,
                                  wsMessageDate: moment(date)
                                    .add(3, "days")
                                    .toDate(),
                                  warmCallDate: moment(date)
                                    .add(4, "days")
                                    .toDate(),
                                  coldCallDate: moment(date)
                                    .add(24, "days")
                                    .toDate(),
                                  iceCallDate: moment(date)
                                    .add(60, "days")
                                    .toDate(),
                                },
                                openModal: true,
                              },
                            });
                          } else if (item.dateField === "wsMessageDate") {
                            dispatch({
                              type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
                              payload: {
                                data: {
                                  ...modalData,
                                  wsMessageDate: date,
                                  warmCallDate: moment(date)
                                    .add(1, "days")
                                    .toDate(),
                                  coldCallDate: moment(date)
                                    .add(21, "days")
                                    .toDate(),
                                  iceCallDate: moment(date)
                                    .add(57, "days")
                                    .toDate(),
                                },
                                openModal: true,
                              },
                            });
                          } else if (item.dateField === "warmCallDate") {
                            dispatch({
                              type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
                              payload: {
                                data: {
                                  ...modalData,
                                  warmCallDate: date,
                                  coldCallDate: moment(date)
                                    .add(20, "days")
                                    .toDate(),
                                  iceCallDate: moment(date)
                                    .add(56, "days")
                                    .toDate(),
                                },
                                openModal: true,
                              },
                            });
                          } else if (item.dateField === "coldCallDate") {
                            dispatch({
                              type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
                              payload: {
                                data: {
                                  ...modalData,
                                  coldCallDate: date,
                                  iceCallDate: moment(date)
                                    .add(36, "days")
                                    .toDate(),
                                },
                                openModal: true,
                              },
                            });
                          } else {
                            dispatch({
                              type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
                              payload: {
                                data: {
                                  ...modalData,
                                  [item.dateField]: date,
                                },
                                openModal: true,
                              },
                            });
                          }
                        }}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/mm/yyyy"
                        locale="az"
                      />
                    </div>
                    {(item.key === "appointed" ||
                      item.key === "appointed-but-not-come") && (
                      <TextField
                        sx={{
                          "& input": {
                            fontSize: "14px",
                            height: "28px",
                            padding: "4px 8px",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          style: {
                            fontSize: "12px",
                            color: "#3F3F3F",
                          },
                        }}
                        id={"constTime"}
                        name={"constTime"}
                        type="time"
                        label="saat"
                        value={modalData?.constTime || ""}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          updateModalState("constTime", e.target.value)
                        }
                        onBlur={(e) => {
                          formik.setFieldTouched("constTime", true);
                          setShrink(!!e.target.value);
                        }}
                        onFocus={() => setShrink(true)}
                      />
                    )}
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
      {formik.errors.status && formik.touched.status && (
        <small className="validation-err-message">{formik.errors.status}</small>
      )}
    </>
  );
};

export default Status;
